import { FormControlSizes, IconButton, IconName } from '@talos/kyoko';
import Big from 'big.js';
import { useEffect, useState } from 'react';

import { Wrapper } from './styles';

const createValidValues = (min: number | string, max?: string | number, multiplier?: string | number) => {
  const validValues: string[] = [];
  if (!min || min === '0') {
    min = 0.00001;
  }
  if (!max || max === '0') {
    max = 1000;
  }
  if (!multiplier || multiplier === '0') {
    multiplier = 10;
  }
  let current = Big(min);
  const maximum = Big(max);
  while (current.lte(maximum)) {
    validValues.push(current.toFixed());
    current = current.times(multiplier);
  }
  return validValues;
};

export interface PriceIncrementProps {
  min: string;
  value: string;
  onChange: (index: number, newIncrement: string) => void;
  size?: FormControlSizes;
}

export function PriceIncrement({ min, value, onChange, size = FormControlSizes.Tiny }: PriceIncrementProps) {
  const [validValues, setValidValues] = useState(() => createValidValues(min));

  useEffect(() => {
    setValidValues(createValidValues(min));
  }, [min]);

  function adjustIncrement(adjustment: -1 | 1) {
    let newIndex = valueIndex + adjustment;
    if (newIndex < 0) {
      newIndex = 0;
    }
    if (newIndex >= validValues.length) {
      newIndex = validValues.length - 1;
    }
    onChange(0, validValues[newIndex]);
  }

  let valueIndex = validValues.indexOf(value);
  if (valueIndex < 0) {
    valueIndex = parseInt(`${validValues.length / 2}`);
  }

  return (
    <Wrapper data-testid="price-increment">
      <IconButton
        data-testid="price-increment-minus"
        ghost
        size={size}
        icon={IconName.Minus}
        onClick={() => adjustIncrement(-1)}
      />
      <div data-testid="price-increment-value">{validValues[valueIndex]}</div>
      <IconButton
        data-testid="price-increment-plus"
        ghost
        size={size}
        icon={IconName.Plus}
        onClick={() => adjustIncrement(+1)}
      />
    </Wrapper>
  );
}
